/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;padding:15px 20px;text-align:center}dialog-title[_ngcontent-%COMP%]{justify-content:center;min-height:40px;align-items:center;min-height:40px;padding-bottom:10px;padding-top:10px}.msg-content[_ngcontent-%COMP%]{text-align:center;word-break:break-word;font-size:1.6em;max-width:90%;margin:1em auto}.msg-content.empty[_ngcontent-%COMP%]{display:none}dialog-actions[_ngcontent-%COMP%]{padding-top:25px;padding-bottom:16px}"];
export { styles as styles };
